import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { Button, Col, Row } from "react-bootstrap";
import ArrowRight from "@/assets/ArrowRight.svg";
import { useLink } from "@/hooks/useLink";
import PropTypes from "prop-types";
import sourceflowEnums from "@/sourceflow.enums";

export const RecruitmentPageBannerSection = ({ className, type,InternalButtonLink }) => {
  const locale = useLocale();
  const link = useLink();
  const pathPrefix = `page.${type}.banner`;

  if (type === null) {
    return null;
  }

  return (
    <Banner
      className={className}
      title={<DynamicText path={`${pathPrefix}.title.${locale}`} tag="h1" />}
      image={{ path: `${pathPrefix}.image`, src: "/assets/banners/default.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`${pathPrefix}.text.${locale}`} className="mb-5" />
          <Button href={InternalButtonLink ?? link("submit-job")} variant="secondary" tabIndex={undefined}>
            <DynamicText path={`${pathPrefix}.button.${locale}`} className="me-4" />
            <ArrowRight width="14" height="12" />
          </Button>
        </Col>
      </Row>
    </Banner>
  );
};

RecruitmentPageBannerSection.defaultProps = {
  type: null,
};

RecruitmentPageBannerSection.propTypes = {
  type: PropTypes.oneOf(sourceflowEnums.config.recruitmentTypes.array),
};
